import MouList from './MouList';
import MouCRU from './MouCRU';
export { MouList, MouCRU };

export const mouOptionObj = {
    mou_date: null,
    lessee: {},
    lessor: {},
    managed: "",
    tied_asset: ""
}